// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"77ab36e7","1543":"c68c1949","3069":"9f58057d","5934":"2e082499","6071":"2e082499","6401":"4a290479","7019":"2e082499","9265":"2e082499"}[chunkId] + ".chunk.css";
};